import { number, object, string, boolean } from 'yup';

export default object().shape({
  id_terminal: number().required('Este campo é obrigatório!'),
  id_proprietario_carga: number().required('Este campo é obrigatório!'),
  data_inicio_operacao: string().required('Este campo é obrigatório!'),
  data_fim_operacao: string().nullable(),
  urgencia: boolean().required('Este campo é obrigatório!'),
  intervalo_acesso_liberado_porto: number().required('Este campo é obrigatório!'),
  valor_tonelada: number().required('Este campo é obrigatório!'),
  tonelada_prevista_transportadas: number().required('Este campo é obrigatório!'),
  toneladas_transportadas: number().required('Este campo é obrigatório!'),
})